import { render, staticRenderFns } from "./DistributionLevelsComponent.vue?vue&type=template&id=1ffe4160&scoped=true&"
import script from "./DistributionLevelsComponent.vue?vue&type=script&lang=js&"
export * from "./DistributionLevelsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DistributionLevelsComponent.vue?vue&type=style&index=0&id=1ffe4160&scoped=true&lang=scss&"
import style1 from "./DistributionLevelsComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffe4160",
  null
  
)

export default component.exports